<template>
  <div class="main-container">
    <div class="top-text-container">
      <div class="loader">
        <svg viewBox="0 0 80 80">
          <rect x="8" y="8" width="64" height="64"></rect>
          <text x="50%" y="60%" text-anchor="middle" fill="black" font-size="24" font-weight="bold">
            F
          </text>
        </svg>
      </div>

      <div class="loader">
        <svg viewBox="0 0 80 80">
          <rect x="8" y="8" width="64" height="64"></rect>
          <text x="50%" y="60%" text-anchor="middle" fill="black" font-size="24" font-weight="bold">
            I
          </text>
        </svg>
      </div>

      <div class="loader">
        <svg viewBox="0 0 80 80">
          <rect x="8" y="8" width="64" height="64"></rect>
          <text x="50%" y="60%" text-anchor="middle" fill="black" font-size="24" font-weight="bold">
            N
          </text>
        </svg>
      </div>
    </div>
    <div class="bottom-text-container">
      <div class="loader">
        <svg viewBox="0 0 80 80">
          <rect x="8" y="8" width="64" height="64"></rect>
          <text x="50%" y="60%" text-anchor="middle" fill="black" font-size="24" font-weight="bold">
            B
          </text>
        </svg>
      </div>
      <div class="loader">
        <svg viewBox="0 0 80 80">
          <rect x="8" y="8" width="64" height="64"></rect>
          <text x="50%" y="60%" text-anchor="middle" fill="black" font-size="24" font-weight="bold">
            O
          </text>
        </svg>
      </div>
      <div class="loader">
        <svg viewBox="0 0 80 80">
          <rect x="8" y="8" width="64" height="64"></rect>
          <text x="50%" y="60%" text-anchor="middle" fill="black" font-size="24" font-weight="bold">
            T
          </text>
        </svg>
      </div>
      <div class="loader">
        <svg viewBox="0 0 80 80">
          <rect x="8" y="8" width="64" height="64"></rect>
          <text x="50%" y="60%" text-anchor="middle" fill="black" font-size="24" font-weight="bold">
            O
          </text>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>


export default {
    name: "loader-spinner",
    components: {

    },
    props: {
      LoaderColor: {
        type: Boolean,
        required: false
      }
    },
    data() {
        return {

        }
    },
    async mounted() {

    },
    methods: {

    },
    watch: {

    }
}
</script>

<style scoped>
    .main-container {
      position: fixed;
        top: 50%;
        left: 0;
        left: 0px;
        transform: translateY(-50%);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        gap: 20px;
    }
    .loader {
      --path: #4A89DC;
      --dot: #A0D468;
      --duration: 3s;
      top: 0px;
      left: 0px;
      transform: translate(0%, -50%);
      width: 44px;
      height: 44px;
      position: relative;
    }
  
    .loader:before {
      content: "";
      width: 6px;
      height: 6px;
      border-radius: 50%;
      position: absolute;
      display: block;
      background: var(--dot);
      top: 37px;
      left: 19px;
      transform: translate(-18px, -18px);
      animation: dotRect var(--duration) cubic-bezier(0.785, 0.135, 0.15, 0.86) infinite;
    }
  
    .loader svg {
      display: block;
      width: 100%;
      height: 100%;
    }
  
    .loader svg rect,
    .loader svg polygon,
    .loader svg circle {
      fill: none;
      stroke: var(--path);
      stroke-width: 10px;
      stroke-linejoin: round;
      stroke-linecap: round;
    }
  
    .loader svg polygon {
      stroke-dasharray: 145 76 145 76;
      stroke-dashoffset: 0;
      animation: pathTriangle var(--duration) cubic-bezier(0.785, 0.135, 0.15, 0.86) infinite;
    }
  
    .loader svg rect {
      stroke-dasharray: 192 64 192 64;
      stroke-dashoffset: 0;
      animation: pathRect 3s cubic-bezier(0.785, 0.135, 0.15, 0.86) infinite;
    }
  
    .loader svg circle {
      stroke-dasharray: 150 50 150 50;
      stroke-dashoffset: 75;
      animation: pathCircle var(--duration) cubic-bezier(0.785, 0.135, 0.15, 0.86) infinite;
    }
  
    .loader.triangle {
      width: 48px;
    }
  
    .loader.triangle:before {
      left: 21px;
      transform: translate(-10px, -18px);
      animation: dotTriangle var(--duration) cubic-bezier(0.785, 0.135, 0.15, 0.86) infinite;
    }
  
    @keyframes pathTriangle {
      33% {
        stroke-dashoffset: 74;
      }
  
      66% {
        stroke-dashoffset: 147;
      }
  
      100% {
        stroke-dashoffset: 221;
      }
    }
  
    @keyframes dotTriangle {
      33% {
        transform: translate(0, 0);
      }
  
      66% {
        transform: translate(10px, -18px);
      }
  
      100% {
        transform: translate(-10px, -18px);
      }
    }
  
    @keyframes pathRect {
      25% {
        stroke-dashoffset: 64;
      }
  
      50% {
        stroke-dashoffset: 128;
      }
  
      75% {
        stroke-dashoffset: 192;
      }
  
      100% {
        stroke-dashoffset: 256;
      }
    }
  
    @keyframes dotRect {
      25% {
        transform: translate(0, 0);
      }
  
      50% {
        transform: translate(18px, -18px);
      }
  
      75% {
        transform: translate(0, -36px);
      }
  
      100% {
        transform: translate(-18px, -18px);
      }
    }
  
    @keyframes pathCircle {
      25% {
        stroke-dashoffset: 125;
      }
  
      50% {
        stroke-dashoffset: 175;
      }
  
      75% {
        stroke-dashoffset: 225;
      }
  
      100% {
        stroke-dashoffset: 275;
      }
    }
  
    .loader {
      display: inline-block;
      margin: 0 16px;
    }
</style>